import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMap",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.763 1.075A.5.5 0 0 1 11 1.5V9a.5.5 0 0 1-.276.447l-3 1.5a.5.5 0 0 1-.448 0L4.5 9.56l-2.776 1.388A.5.5 0 0 1 1 10.5V3a.5.5 0 0 1 .276-.447l3-1.5a.5.5 0 0 1 .448 0L7.5 2.44l2.776-1.388a.5.5 0 0 1 .487.022ZM7 3.309l-2-1v6.382l2 1V3.309Zm1 6.382 2-1V2.309l-2 1v6.382Zm-4-1V2.309l-2 1v6.382l2-1Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, p, i, f, h, a) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--map"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Map",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", u]]);
export {
  I as default
};
//# sourceMappingURL=map.js.map
